
<template>
    <div id="wrapper" :key="valuekey">
        <div class="col-xl-10">
            <div class="card-box">
                <div class="Chart">
                    <canvas id="orderHolder" width="60" height="50"></canvas>
                </div>
            </div>
            <div v-if="total && total > 0" style="font-size:15px; text-align:center;">
                <label>Total:</label> {{total}}
            </div>
        </div>
    </div>
</template>
            
<script>
import Chart from 'chart.js';
import Controller from './CrtOrderHolder';
export default {
  
    name: 'OrderHolder',
    components: {
    },
    
    data() {
    return {
        chart: null,
        total: 0,

      }
    },
    methods: Controller.methods,
    created() {
      Controller.init(this);
    },
    mounted() {

        const ctx = document.getElementById('orderHolder');
        this.chart = new Chart(ctx, {
          type: 'line',
          data: {
            datasets: [{ 
                    label: 'Pedidos',
                    data: null,
                    backgroundColor: "#EBCB38",
                    borderColor: "#EBCB38",
                    fill: false,
                }],
                labels: null,
        },
        options: { 
			tooltips: {
				mode: 'index',
				intersect: false,
			},
			hover: {
				mode: 'nearest',
				intersect: true
			},
			scales: {
				xAxes: [{
					display: true,
					scaleLabel: {
						display: true,
						labelString: 'Ano-Mês'
					}
				}],
				yAxes: [{
					display: true,
					scaleLabel: {
						display: true,
						labelString: 'Pedidos'
					}
				}]
			},
            title: {
                display: true, 
            },
            legend: {
                fullWidth: true,
                labels: {
                    fontColor: '#000',
                    boxWidth: 20, 
                }
            },
        }
      });
      this.filter();
    }
}
    

</script>
